import React, { useMemo, useState } from "react";
import { GET_REF_TASK_LIST } from "./services/get-ref-task-list";
import { useDispatch, useSelector } from "react-redux";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../common_components/common_widgets/data-grid";
import { getDataGridActionEllipsisComponent } from "../../common_components/common_widgets/data-grid-action-ellipsis";
import {
  defaultTakTemplateFormData,
  RESET_TASK_TEMPLATE_POPUP_VALIDATION,
  SET_TASK_TEMPLATE_DATAGRID_FILTER,
  SET_TASK_TEMPLATE_FORM_DATA,
  TOGGLE_ADD_TASK_TEMPLATE_POPUP,
  TOGGLE_REF_TASK_LIST_ACTION_POPOVER,
  TOGGLE_TASK_TEMPLATE_WARNING_POPUP,
} from "./reducers/task-template-reducer";
import { actions, callOperation } from "async-ops";
import { useEffect } from "react";
import MdaeActionPopover from "../../common_components/common_widgets/menu-action-popover";
import "./index.scss";
import AddTaskTemplatePopup, {
  openTaskTemplateInEditMode,
} from "./add-task-template";
import { GET_TASK_TEMPLATE_REFERENCE_DATA } from "./services/get-reference-data";
import { GET_TASK_TEMPLATE_AUDIT_GROUP_LIST } from "./services/get-audit-group-list";
import { cloneDeep, first, isEqual } from "lodash";
import { getUserPermissionObject } from "../../common_components/user-permissions-helper";
import MdaeAddButton from "../../common_components/common_widgets/add-button";
import { COPY_REF_TASK } from "./services/copy-ref-task";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../common_components/common_widgets/toast/notify";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_CONFIRMATION_POPUP,
} from "../../common_components/mdae-common-reducer";
import { GET_TASK_TEMPLATE_LINKED_DATA } from "./services/get-task-template-linked-data";
import { DELETE_REF_TASK } from "./services/delete-ref-task";
import { TOGGLE_BULK_UPDATE_POPUP } from "../../common_components/bulk-update-popup/reducers/bulk-update-popup-reducer";
import { BULK_UPDATE_CONFIG_NAMES } from "../../common_components/bulk-update-popup/bulk-update-configuration";
import BulkUpdatePopup from "../../common_components/bulk-update-popup";
import { resolve } from "path";
import { GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP } from "../user-management/external-users/services/get-active-external-user-list-for-user-group";
import { GET_EXTERNAL_USER_GROUP_LIST } from "../user-management/external-users/services/get-external-user-group-list";
import { GET_TASK_GROUP_LIST } from "../user-management/task-groups/services/get-task-group-list";

export const TASK_TEMPLATE_POPUP_MODE = {
  ADD: "ADD",
  EDIT: "EDIT",
};
export const TASK_TEMPLATE_WARNING_POPUP_MODE = {
  CHANGES_ON_EXISTING_USER_TASKS_WARNING:
    "CHANGES_ON_EXISTING_USER_TASKS_WARNING",
  CHNAGES_ON_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING:
    "CHNAGES_ON_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING",
  CANNOT_CHANGE_AUDIT_GROUPS_FOR_TASKS_LINKED_TO_PATHWAYS_WARNING:
    "CANNOT_CHANGE_AUDIT_GROUPS_FOR_TASKS_LINKED_TO_PATHWAYS_WARNING",
  DELETE_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING:
    "DELETE_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING",
  DELETE_TASK_TEMPLATE_LINKED_TO_PROCESS_TEMPLATE:
    "DELETE_TASK_TEMPLATE_LINKED_TO_PROCESS_TEMPLATE",
};
const deletTasktemplateMessage =
  "Deleting this task template cannot be undone. Do you want to continue?";

export const deleteRefTask = (refTaskData, dispatch) => {
  return new Promise<void>((resolve, reject) => {
    dispatch({ type: SHOW_LOADER });
    callOperation(DELETE_REF_TASK, refTaskData)
      .then(function(response) {
        if (response.isSaved) {
          dispatch(actions.asyncOperationStart(GET_REF_TASK_LIST, {}));
          resolve();
        }
      })
      .finally(() => {
        dispatch({ type: HIDE_LOADER });
      });
  });
};
const TaskTemplate: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const taskTemplatePopupMode = useSelector(
    (state: any) => state.taskTemplateReducer.taskTemplatePopupMode,
    isEqual
  );
  const currentUser = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.currentUser,
    isEqual
  );
  const taskTemplatePermissions = getUserPermissionObject(
    "TASK_TEMPLATE",
    currentUser
  );
  const currentUrlSearchParams = new URLSearchParams(
    window.location.href.split("?")[1]
  );
  const [taskTemplateDataGridInstance, setTaskTemplateDataGridInstance] = useState(null);
  const getCurrentSelectedRowData: any = () => {
    return first(taskTemplateDataGridInstance?.getSelectedRowsData());
  };
  for (let parameterPair of currentUrlSearchParams.entries() as any) {
    if (parameterPair[0] && parameterPair[0].toLowerCase() === "categoryid") {
      const categoryId = parseInt(parameterPair[1]);
      if (!isNaN(categoryId) && categoryId > 0) {
        dispatch({
          type: SET_TASK_TEMPLATE_DATAGRID_FILTER,
          data: {
            taskTemplateDataGridFilter: ["taskCategoryId", "=", categoryId],
          },
        });
      }
    }
  }
  useEffect(() => {
    dispatch(actions.asyncOperationStart(GET_REF_TASK_LIST, {}));
    dispatch(
      actions.asyncOperationStart(GET_TASK_TEMPLATE_AUDIT_GROUP_LIST, {})
    );
    dispatch(actions.asyncOperationStart(GET_TASK_TEMPLATE_REFERENCE_DATA, {}));
    dispatch(actions.asyncOperationStart(GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP, {}));
    dispatch(actions.asyncOperationStart(GET_EXTERNAL_USER_GROUP_LIST, {}));
    dispatch(actions.asyncOperationStart(GET_TASK_GROUP_LIST, {}));
  }, []);
  const toggleRefTaskListActionPopover = (isVisible, target) => {
    dispatch({
      type: TOGGLE_REF_TASK_LIST_ACTION_POPOVER,
      data: {
        refTaskListDataGridActionPopoverTarget: target,
        isRefTaskListDataGridActionPopoverVisible: isVisible,
      },
    });
  };

  const toggleTaskTemplatePopup = (
    isVisible,
    title = "Create New Task Template",
    mode = TASK_TEMPLATE_POPUP_MODE.ADD
  ) => {
    dispatch({
      type: TOGGLE_ADD_TASK_TEMPLATE_POPUP,
      data: {
        taskTemplatePopupMode: mode,
        taskTemplatePopupTitle: title,
        isAddTaskTemplatePopupVisible: isVisible,
      },
    }); 
    if(!isVisible){
      dispatch({
        type: SET_TASK_TEMPLATE_FORM_DATA,
        data: {
          taskTemplateFormData: {
            moduleTypeValue: null,
          },
        },
      }); 
    }   
  };
  const hideConfirmationPopup = () => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        visible: false,
      },
    });
  };
  const showConfirmationPopup = (message) => {
    toggleRefTaskListActionPopover(false, null);
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: () => {
          toggleRefTaskListActionPopover(false, null);
          deleteRefTask(getCurrentSelectedRowData(), dispatch).then(() => {
            hideConfirmationPopup();
          });
        },
        visible: true,
        confirmShown: true,
        declineShown: true,
        width: 380,
        height: 200,
        contentHtml: message,
        onDecline: hideConfirmationPopup,
      },
    });
  };
  const toggleConfirmationPopupVisible = (isVisible, message) => {
    if (isVisible) {
      showConfirmationPopup(message);
    } else {
      hideConfirmationPopup();
    }
  };
  const toggleTaskTemplateWarningPopupVisible = (isVisible, popupMode) => {
    dispatch({
      type: TOGGLE_TASK_TEMPLATE_WARNING_POPUP,
      data: {
        isTaskTemplateWarningPopupVisible: isVisible,
        taskTemplateWarningPopupMode: popupMode,
      },
    });
  };
  const refTaskListActionPopoverMenuList = () => [
    {
      text: taskTemplatePermissions.hasUpdateAccess ? "Edit" : "Preview",
      icon: () => {
        return (
          <div
            style={{ height: "14px" }}
            className={
              taskTemplatePermissions.hasUpdateAccess
                ? "edit-action-icon"
                : "preview-action-icon"
            }
          ></div>
        );
      },
      onClick: () => {
        toggleRefTaskListActionPopover(false, null);
        openTaskTemplateInEditMode(
          getCurrentSelectedRowData(),
          toggleTaskTemplatePopup,
          dispatch
        );
      },
    },
    {
      text: "Copy",
      icon: () => {
        return (
          <div style={{ height: "16px" }} className={"copy-action-icon"}></div>
        );
      },
      visible: taskTemplatePermissions.hasCreateAccess,
      onClick: () => {
        toggleRefTaskListActionPopover(false, null);
        copyTaskTemplate(getCurrentSelectedRowData(), dispatch);
      },
    },
    {
      text: "Delete",
      visible:
        taskTemplatePermissions.hasDeleteAccess &&
        !getCurrentSelectedRowData()?.curatedInd,
      icon: () => {
        return (
          <div
            style={{ height: "16px" }}
                className={"delete-action-icon"}
          ></div>
        );
      },
      onClick: () => {
        const currentSelectedRowData = getCurrentSelectedRowData();
        if (!currentSelectedRowData.curatedInd) {
          dispatch({ type: SHOW_LOADER });
          callOperation(
            GET_TASK_TEMPLATE_LINKED_DATA,
            currentSelectedRowData.refTaskId
          )
            .then(function(response) {
              if (
                response.attachedProcessTemplate &&
                response.attachedProcessTemplate.length > 0
              ) {
                dispatch({
                  type: SET_TASK_TEMPLATE_FORM_DATA,
                  data: {
                    taskTemplateFormData: cloneDeep(currentSelectedRowData),
                  },
                });
                toggleRefTaskListActionPopover(false, null);
                toggleTaskTemplateWarningPopupVisible(
                  true,
                  TASK_TEMPLATE_WARNING_POPUP_MODE.DELETE_TASK_TEMPLATE_LINKED_TO_PROCESS_TEMPLATE
                );
              }
              else if (
                response.attachedAuditPathways &&
                response.attachedAuditPathways.length > 0
              ) {
                dispatch({
                  type: SET_TASK_TEMPLATE_FORM_DATA,
                  data: {
                    taskTemplateFormData: cloneDeep(currentSelectedRowData),
                  },
                });
                toggleRefTaskListActionPopover(false, null);
                toggleTaskTemplateWarningPopupVisible(
                  true,
                  TASK_TEMPLATE_WARNING_POPUP_MODE.DELETE_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING
                );
              } else toggleConfirmationPopupVisible(true, deletTasktemplateMessage);
            })
            .finally(() => {
              dispatch({ type: HIDE_LOADER });
            });
        }
      },
    },
  ];

  const refTaskListDataGridOptions = useMemo(() => {
    return getRefTaskListDataGridOptions(
      toggleRefTaskListActionPopover,
      dispatch,
      setTaskTemplateDataGridInstance
    );
  }, []);

  const resetTaskTemplatePopupValidation = () => {
    dispatch({
      type: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
      data: {
        isTaskTemplateFormDataValid: true,
      },
    });
  };

  const renderToolbarButtonTemplate = () => {
    return (
      <MdaeAddButton
        id={"btnAddNewTaskTemplate"}
        title={"Create New Task Template"}
        visible={taskTemplatePermissions.hasCreateAccess}
        onClick={() => {
          dispatch({
            type: SET_TASK_TEMPLATE_FORM_DATA,
            data: {
              taskTemplateFormData: cloneDeep(defaultTakTemplateFormData),
              initialTaskTemplateFormData: cloneDeep(
                defaultTakTemplateFormData
              ),
            },
          });
          taskTemplateDataGridInstance?.deselectAll();
          resetTaskTemplatePopupValidation();
          toggleTaskTemplatePopup(true);
        }}
      ></MdaeAddButton>
    );
  };
  return (
    <div className={"page-container-padding"}>
      <MdaeActionPopover
        mdaePopoverConfig={{
          id: "pnlRefTaskListActionPopover",
          mdaeDataUpdaterConfig: [
            {
              actionType: TOGGLE_REF_TASK_LIST_ACTION_POPOVER,
              reducerName: "taskTemplateReducer",
              widgetOptionBindings: {
                target: "refTaskListDataGridActionPopoverTarget",
                visible: "isRefTaskListDataGridActionPopoverVisible",
              },
            },
          ],
        }}
        menuItemListFunction={refTaskListActionPopoverMenuList}
      ></MdaeActionPopover>
      <MdaeDataGrid
        {...refTaskListDataGridOptions}
        mdaeDataGridCustomButtons={renderToolbarButtonTemplate}
      ></MdaeDataGrid>
      <AddTaskTemplatePopup
        getCurrentSelectedRowData={getCurrentSelectedRowData}
        toggleTaskTemplatePopup={toggleTaskTemplatePopup}
        taskTemplatePopupMode={taskTemplatePopupMode}
      ></AddTaskTemplatePopup>
    </div>
  );
};

const getRefTaskListDataGridOptions = (
  toggleActionPopover,
  dispatch,
  setTaskTemplateDataGridInstance
) => {
  const sampleDataGridOption: IMdaeDataGridProps = {
    id: "pnlRefTaskList",
    stateStoring: {
      enabled: true,
      type: "localStorage",
      storageKey: "task-template-data-grid-storage-key",
    },
    mdaeColumnChooser: { isMdaeColumnChooserVisible: true },
    mdaeSearchPanel: { visible: true },
    clearFilterButtonId: "btn-ref-task-list-grid-clear-filter",
    export: {
      enabled: true,
      fileName: "TaskTemplates",
    },
    headerFilter: {
      visible: true,
    },
    allowColumnResizing: true,
    allowColumnReordering: true,
    filterRow: {
      visible: true,
    },
    onInitialized(e) {
      setTaskTemplateDataGridInstance(e.component);
    },
    mdaeColumns: [
      {
        fixed: true,
        alignment: "center",
        cellRender: (e) => {
          return getDataGridActionEllipsisComponent(e, {
            showActionPopover: toggleActionPopover,
            entityName: "ref-task",
            entityId: e.data.refTaskId,
            currentRowData: e.data,
            type: 'usingDispatch',
            dispatch
          });
        },
        width: 50,
      },
      { caption: "Name", dataField: "name", width: 200, fixed: true },
      {
        dataField: "taskCategoryId",
        visible: false,
        showInColumnChooser: false,
      },
      {
        caption: "Display Name",
        dataField: "displayName",
        width: 200,
        fixed: true,
      },
      { caption: "Module", dataField: "moduleTypeDisplayName", width: 150 },
      { caption: "Level", dataField: "levelDisplayName", width: 100 },
      {
        caption: "Curated",
        dataField: "curatedDisplayName",
        width: 100,
        alignment: "center",
      },
      { caption: "Category", dataField: "taskCategoryName", width: 150 },
      {
        caption: "Description",
        dataField: "description",
        width: 400,
      },
      {
        caption: "Audit Groups",
        dataField: "auditGroupNames",
        width: 350,
      },
      {
        caption: "Effective Date",
        dataField: "effectiveDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
      },
      {
        caption: "Term Date",
        dataField: "termDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
      },
      { caption: "Created By", dataField: "createdBy", width: 120 },
      {
        caption: "Created On",
        dataField: "createDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
      },
      { caption: "Updated By", dataField: "updatedBy", width: 120 },
      {
        caption: "Update Date",
        dataField: "updateDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
      },
    ],
    mdaeDataUpdaterConfig: [
      {
        actionType: GET_REF_TASK_LIST,
        isAsyncComplete: true,
        widgetOptionBindings: {
          dataSource: "refTaskList",
        },
      },
      {
        actionType: SET_TASK_TEMPLATE_DATAGRID_FILTER,
        reducerName: "taskTemplateReducer",
        widgetOptionBindings: {
          filterValue: "taskTemplateDataGridFilter",
        },
      },
    ],
  };
  return sampleDataGridOption;
};

const copyTaskTemplate = (currentSelectedRowData, dispatch) => {
  dispatch({ type: SHOW_LOADER });
  callOperation(COPY_REF_TASK, {
    refTaskId: currentSelectedRowData.refTaskId,
  }).then(function(response) {
    dispatch({ type: HIDE_LOADER });
    if (response.isSaved) {
      dispatch(actions.asyncOperationStart(GET_REF_TASK_LIST, {}));
      mdaeNotify({
        message: response.refTaskName + " - task template saved successfully.",
        messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
      });
    } else {
      mdaeNotify({
        message: "Unable to save task template",
        messageType: NOTIFY_MESSAGE_TYPE.ERROR,
      });
    }
  });
};

export default TaskTemplate;
